import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

import doubbleArrowIcon from '@assets/vaults/manageLiquidity/doubbleArrow.svg?url';
import documentsIcon from '@assets/vaults/menu/documents.svg?url';

import Link from '@components/common/Link';
import Tooltip from '@components/common/Tooltip';

import { Size } from '@constants/common/ui.constants';
import { AILM_DOCS } from '@constants/vaults/common.constants';

import useStyles from './styles.module';

const RangeSelectionTooltip: FC = () => {
  const { classes } = useStyles();

  return (
    <Tooltip>
      <div className={classes.inner}>
        <img src={doubbleArrowIcon} alt="" className={classes.icon} />
        <div className={classes.content}>
          <Typography variant="h4">Range Selection</Typography>
          <Typography variant="body2">
            Automatic (AiLM) vs Manual (ALM)
          </Typography>

          <Typography variant="caption1">
            Let us continually manage the price range with our AiLM (Automated
            Intelligent Liquidity Manager) or select the manual option (ALM) to
            set a custom range/ Both options offer automated harvests and
            rebalancing
          </Typography>

          <div className={classes.learnMore}>
            <img src={documentsIcon} alt="" className={classes.docsIcon} />
            <Typography variant="caption1">Learn more in our</Typography>
            <Link
              title="Documentation"
              href={AILM_DOCS}
              newTab
              isUnderline={false}
              size={Size.Small}
            />
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default RangeSelectionTooltip;
